package org.multipaz.utopia.generated

/**
 * Generated strings for language: vi
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_vi = mapOf(
    "boarding_pass_attribute_departure_time" to "Thời gian khởi hành",
    "boarding_pass_attribute_flight_number" to "Số hiệu chuyến bay",
    "boarding_pass_attribute_passenger_name" to "Tên hành khách",
    "boarding_pass_attribute_seat_number" to "Số ghế",
    "boarding_pass_description_departure_time" to "Ngày và giờ khởi hành",
    "boarding_pass_description_flight_number" to "Số hiệu chuyến bay",
    "boarding_pass_description_passenger_name" to "Họ, tên đệm hoặc mã định danh chính của người giữ mDL.",
    "boarding_pass_description_seat_number" to "Số ghế",
    "cor_attribute_administrative_number" to "Số hành chính",
    "cor_attribute_date_of_arrival" to "Ngày đến",
    "cor_attribute_date_of_birth" to "Ngày sinh",
    "cor_attribute_date_of_expiry" to "Ngày hết hạn",
    "cor_attribute_date_of_issue" to "Ngày cấp",
    "cor_attribute_document_number" to "Số tài liệu",
    "cor_attribute_family_name" to "Họ",
    "cor_attribute_gender" to "Giới tính",
    "cor_attribute_given_names" to "Tên",
    "cor_attribute_issuing_authority" to "Cơ quan cấp",
    "cor_attribute_issuing_country" to "Quốc gia cấp",
    "cor_attribute_issuing_jurisdiction" to "Thẩm quyền cấp",
    "cor_attribute_nationality" to "Quốc tịch",
    "cor_attribute_older_than_18" to "Trên 18 tuổi",
    "cor_attribute_older_than_21" to "Trên 21 tuổi",
    "cor_attribute_place_of_birth" to "Nơi sinh",
    "cor_attribute_resident_address" to "Địa chỉ cư trú",
    "cor_attribute_resident_city" to "Thành phố cư trú",
    "cor_attribute_resident_country" to "Quốc gia cư trú",
    "cor_attribute_resident_house_number" to "Số nhà cư trú",
    "cor_attribute_resident_postal_code" to "Mã bưu chính cư trú",
    "cor_attribute_resident_state" to "Tiểu bang cư trú",
    "cor_attribute_resident_street" to "Đường cư trú",
    "cor_description_administrative_number" to "Số được Nhà cung cấp COR chỉ định cho mục đích kiểm soát kiểm toán hoặc các mục đích khác.",
    "cor_description_date_of_arrival" to "Ngày, tháng, năm người giữ COR đến EU.",
    "cor_description_date_of_birth" to "Ngày, tháng, năm sinh của người giữ COR. Nếu không rõ, hãy điền ngày sinh ước tính.",
    "cor_description_date_of_expiry" to "Ngày (và có thể là giờ) hết hạn COR.",
    "cor_description_date_of_issue" to "Ngày (và có thể là giờ) cấp COR.",
    "cor_description_document_number" to "Số của COR, được chỉ định bởi Nhà cung cấp COR.",
    "cor_description_family_name" to "Họ hiện tại hoặc mã định danh chính của người giữ COR",
    "cor_description_gender" to "Giới tính của chủ sở hữu COR.",
    "cor_description_given_names" to "Tên hiện tại, các tên khác hoặc mã định danh phụ của người giữ COR",
    "cor_description_issuing_authority" to "Tên của cơ quan hành chính đã cấp phiên bản COR này, hoặc mã quốc gia Alpha-2 ISO 3166 của Quốc gia Thành viên tương ứng nếu không có cơ quan riêng biệt được ủy quyền cấp COR.",
    "cor_description_issuing_country" to "Mã quốc gia Alpha-2, theo định nghĩa trong ISO 3166-1, của quốc gia hoặc lãnh thổ của cơ quan cấp phép.",
    "cor_description_issuing_jurisdiction" to "Mã phân khu quốc gia của khu vực tài phán đã cấp COR, theo định nghĩa trong ISO 3166-2:2020, Điều 8. Phần đầu tiên của mã PHẢI giống với giá trị của issuing_country.",
    "cor_description_nationality" to "Mã quốc gia Alpha-2 theo ISO 3166-1, thể hiện quốc tịch của người dùng.",
    "cor_description_older_than_18" to "Trên 18 tuổi?",
    "cor_description_older_than_21" to "Trên 21 tuổi?",
    "cor_description_place_of_birth" to "Nơi sinh của chủ sở hữu COR.",
    "cor_description_resident_address" to "Địa chỉ đầy đủ nơi người giữ COR hiện đang cư trú và/hoặc có thể liên hệ (số nhà/đường, khu vực, v.v.).",
    "cor_description_resident_city" to "Thành phố nơi chủ sở hữu COR hiện đang cư trú.",
    "cor_description_resident_country" to "Quốc gia mà người dùng hiện đang cư trú, dưới dạng mã quốc gia Alpha-2 theo ISO 3166-1.",
    "cor_description_resident_house_number" to "Số nhà nơi người dùng hiện đang cư trú, bao gồm cả tiền tố hoặc hậu tố.",
    "cor_description_resident_postal_code" to "Mã bưu chính của nơi chủ sở hữu COR hiện đang cư trú.",
    "cor_description_resident_state" to "Bang, tỉnh, quận/huyện hoặc khu vực địa phương nơi người dùng hiện đang cư trú.",
    "cor_description_resident_street" to "Tên đường nơi người dùng hiện đang cư trú.",
    "cor_request_age_over_18" to "Tuổi trên 18",
    "cor_request_all_data_elements" to "Tất cả yếu tố dữ liệu",
    "cor_request_mandatory_data_elements" to "Yếu tố dữ liệu bắt buộc",
    "document_display_name_boarding_pass" to "Thẻ lên máy bay",
    "document_display_name_certificate_of_residency" to "Giấy chứng nhận cư trú",
    "document_display_name_german_personal_id" to "Căn cước công dân Đức",
    "document_display_name_loyalty_card" to "Thẻ khách hàng thân thiết",
    "document_display_name_movie_ticket" to "Vé xem phim",
    "document_display_name_naturalization_certificate" to "Giấy chứng nhận nhập tịch",
    "document_display_name_payment_card" to "Thẻ thanh toán",
    "german_id_attribute_administrative_number" to "Số hành chính",
    "german_id_attribute_age_in_years" to "Tuổi",
    "german_id_attribute_city_of_birth" to "Thành phố sinh",
    "german_id_attribute_country_of_birth" to "Quốc gia sinh",
    "german_id_attribute_date_of_birth" to "Ngày sinh",
    "german_id_attribute_date_of_expiry" to "Ngày hết hạn",
    "german_id_attribute_date_of_issue" to "Ngày cấp",
    "german_id_attribute_document_number" to "Số tài liệu",
    "german_id_attribute_family_name" to "Họ",
    "german_id_attribute_family_name_at_birth" to "Họ khai sinh",
    "german_id_attribute_gender" to "Giới tính",
    "german_id_attribute_given_names" to "Tên",
    "german_id_attribute_issuing_authority" to "Cơ quan cấp",
    "german_id_attribute_issuing_country" to "Quốc gia cấp",
    "german_id_attribute_issuing_jurisdiction" to "Cơ quan cấp",
    "german_id_attribute_nationality" to "Quốc tịch",
    "german_id_attribute_older_than_12" to "Trên 12 tuổi",
    "german_id_attribute_older_than_14" to "Trên 14 tuổi",
    "german_id_attribute_older_than_16" to "Trên 16 tuổi",
    "german_id_attribute_older_than_18" to "Trên 18 tuổi",
    "german_id_attribute_older_than_21" to "Trên 21 tuổi",
    "german_id_attribute_older_than_65" to "Trên 65 tuổi",
    "german_id_attribute_place_of_birth" to "Nơi sinh",
    "german_id_attribute_resident_address" to "Địa chỉ cư trú",
    "german_id_attribute_resident_city" to "Thành phố cư trú",
    "german_id_attribute_resident_country" to "Quốc gia cư trú",
    "german_id_attribute_resident_postal_code" to "Mã bưu chính cư trú",
    "german_id_attribute_state_of_birth" to "Bang sinh",
    "german_id_attribute_year_of_birth" to "Năm sinh",
    "german_id_description_administrative_number" to "Một số được cấp bởi Nhà cung cấp PID cho mục đích kiểm soát kiểm toán hoặc các mục đích khác.",
    "german_id_description_age_in_years" to "Tuổi của người giữ PID tính theo năm",
    "german_id_description_city_of_birth" to "Thành phố, thị xã, thị trấn hoặc làng xã nơi Người sở hữu PID được sinh ra",
    "german_id_description_country_of_birth" to "Quốc gia nơi Người dùng PID sinh ra, dưới dạng mã quốc gia Alpha-2 như được quy định trong ISO 3166-1",
    "german_id_description_date_of_birth" to "Ngày, tháng, và năm sinh của người giữ PID. Nếu không biết, ngày sinh ước tính.",
    "german_id_description_date_of_expiry" to "Ngày (và có thể cả thời gian) PID hết hạn.",
    "german_id_description_date_of_issue" to "Ngày (và có thể cả thời gian) PID được cấp.",
    "german_id_description_document_number" to "Một số cho PID, được cấp bởi Nhà cung cấp PID.",
    "german_id_description_family_name" to "Họ hiện tại, hoặc định danh chính của người giữ PID",
    "german_id_description_family_name_at_birth" to "Họ, tên đệm hoặc định danh chính của người giữ PID lúc sinh",
    "german_id_description_gender" to "Giới tính của người sở hữu PID",
    "german_id_description_given_names" to "Tên hiện tại, tên khác, hoặc định danh phụ của người giữ PID",
    "german_id_description_issuing_authority" to "Tên của cơ quan hành chính đã cấp phiên bản PID này, hoặc mã quốc gia Alpha-2 ISO 3166 của Quốc gia Thành viên tương ứng nếu không có cơ quan riêng biệt được ủy quyền cấp PID.",
    "german_id_description_issuing_country" to "Mã quốc gia Alpha-2, theo định nghĩa trong ISO 3166-1, của quốc gia hoặc lãnh thổ của cơ quan cấp.",
    "german_id_description_issuing_jurisdiction" to "Mã phân chia quốc gia của khu vực pháp lý đã cấp PID, theo định nghĩa trong ISO 3166-2:2020, Điều khoản 8. Phần đầu tiên của mã PHẢI giống với giá trị của quốc gia cấp.",
    "german_id_description_nationality" to "Danh sách mã quốc gia Alpha-2 theo quy định trong ISO 3166-1, thể hiện quốc tịch của Người sở hữu PID.",
    "german_id_description_older_than_12" to "Trên 12 tuổi?",
    "german_id_description_older_than_14" to "Trên 14 tuổi?",
    "german_id_description_older_than_16" to "Trên 16 tuổi?",
    "german_id_description_older_than_18" to "Trên 18 tuổi?",
    "german_id_description_older_than_21" to "Trên 21 tuổi?",
    "german_id_description_older_than_65" to "Trên 65 tuổi?",
    "german_id_description_place_of_birth" to "Quốc gia và đô thị hoặc tỉnh/tiểu bang nơi người giữ PID sinh ra",
    "german_id_description_resident_address" to "Địa chỉ đầy đủ nơi người sở hữu PID hiện đang cư trú và/hoặc có thể liên hệ được (số nhà/đường, thành phố, v.v.)",
    "german_id_description_resident_city" to "Thành phố nơi người sở hữu PID hiện đang cư trú",
    "german_id_description_resident_country" to "Quốc gia nơi Người sở hữu PID hiện đang cư trú, dưới dạng mã quốc gia Alpha-2 theo quy định trong ISO 3166-1",
    "german_id_description_resident_postal_code" to "Mã bưu chính của nơi người sở hữu PID hiện đang cư trú",
    "german_id_description_state_of_birth" to "Tiểu bang, tỉnh, quận/huyện hoặc khu vực địa phương nơi Người dùng PID sinh ra",
    "german_id_description_year_of_birth" to "Năm sinh của người giữ PID",
    "german_id_request_age_over_18" to "Tuổi trên 18",
    "german_id_request_all_data_elements" to "Tất cả các yếu tố dữ liệu",
    "german_id_request_mandatory_data_elements" to "Các yếu tố dữ liệu bắt buộc",
    "loyalty_attribute_date_of_expiry" to "Ngày hết hạn",
    "loyalty_attribute_date_of_issue" to "Ngày phát hành",
    "loyalty_attribute_family_name" to "Họ",
    "loyalty_attribute_given_names" to "Tên",
    "loyalty_attribute_membership_id" to "ID thành viên",
    "loyalty_attribute_photo_of_holder" to "Ảnh của chủ thẻ",
    "loyalty_attribute_tier" to "Hạng",
    "loyalty_description_date_of_expiry" to "Ngày hết hạn tài liệu",
    "loyalty_description_date_of_issue" to "Ngày phát hành tài liệu",
    "loyalty_description_family_name" to "Họ hoặc định danh chính của người giữ tài liệu",
    "loyalty_description_given_names" to "Tên hoặc định danh phụ của người giữ tài liệu",
    "loyalty_description_membership_id" to "Mã định danh cá nhân của chủ thẻ hội viên",
    "loyalty_description_photo_of_holder" to "Ảnh chân dung của người giữ tài liệu",
    "loyalty_description_tier" to "Hạng thành viên (cơ bản, bạc, vàng, bạch kim, cao cấp)",
    "loyalty_request_all_data_elements" to "Tất cả các yếu tố dữ liệu",
    "loyalty_request_mandatory_data_elements" to "Các yếu tố dữ liệu bắt buộc",
    "movie_ticket_attribute_age_rating_code" to "Mã phân loại độ tuổi",
    "movie_ticket_attribute_cinema_theater" to "Rạp chiếu phim",
    "movie_ticket_attribute_date_and_time_of_show" to "Ngày giờ chiếu",
    "movie_ticket_attribute_movie_poster" to "Áp phích phim",
    "movie_ticket_attribute_movie_title" to "Tên phim",
    "movie_ticket_attribute_parking" to "Đỗ xe",
    "movie_ticket_attribute_seat" to "Ghế",
    "movie_ticket_attribute_theater" to "Rạp",
    "movie_ticket_attribute_ticket_number" to "Số vé",
    "movie_ticket_description_age_rating_code" to "Mã phân loại độ tuổi phim",
    "movie_ticket_description_cinema_theater" to "Tên rạp chiếu phim và/hoặc địa chỉ/vị trí của nơi vào cửa.",
    "movie_ticket_description_date_and_time_of_show" to "Ngày và giờ chiếu phim",
    "movie_ticket_description_movie_poster" to "Áp phích phim",
    "movie_ticket_description_movie_title" to "Tên phim, tiêu đề và bất kỳ thông tin nhận dạng buổi chiếu nào khác.",
    "movie_ticket_description_parking" to "Đỗ xe",
    "movie_ticket_description_seat" to "Chỗ ngồi",
    "movie_ticket_description_theater" to "Rạp (phòng chiếu)",
    "movie_ticket_description_ticket_number" to "Số nhận dạng/tham chiếu vé được cấp tại thời điểm mua hàng.",
    "movie_ticket_request_all_data_elements" to "Tất cả các yếu tố dữ liệu",
    "movie_ticket_request_prepaid_parking" to "Đỗ xe trả trước",
    "movie_ticket_request_ticket_number" to "Số vé",
    "naturalization_attribute_date_of_birth" to "Ngày sinh",
    "naturalization_attribute_date_of_naturalization" to "Ngày nhập tịch",
    "naturalization_attribute_family_name" to "Họ",
    "naturalization_attribute_given_names" to "Tên",
    "naturalization_description_date_of_birth" to "Ngày, tháng và năm sinh của người nhập tịch. Nếu không rõ, hãy ghi ngày sinh ước tính.",
    "naturalization_description_date_of_naturalization" to "Ngày (và có thể cả thời gian) người đó được nhập tịch.",
    "naturalization_description_family_name" to "Họ (các) hiện tại, họ hoặc định danh chính của người nhập tịch",
    "naturalization_description_given_names" to "Tên (các) hiện tại, tên khác hoặc định danh phụ của người nhập tịch",
    "naturalization_request_all_data_elements" to "Tất cả các yếu tố dữ liệu",
    "payment_attribute_expiry_date" to "Ngày hết hạn",
    "payment_attribute_holder_name" to "Tên chủ thẻ",
    "payment_attribute_issue_date" to "Ngày phát hành",
    "payment_attribute_issuer_name" to "Tên tổ chức phát hành",
    "payment_attribute_masked_account_reference" to "Tham chiếu tài khoản đã che",
    "payment_attribute_payment_instrument_id" to "Mã định danh phương tiện thanh toán",
    "payment_description_expiry_date" to "Ngày thông tin xác thực này hết hạn.",
    "payment_description_holder_name" to "Tên chủ tài khoản thanh toán.",
    "payment_description_issue_date" to "Ngày cấp thông tin xác thực này.",
    "payment_description_issuer_name" to "Tên tổ chức phát hành dễ đọc.",
    "payment_description_masked_account_reference" to "Tham chiếu tài khoản bị che, ví dụ: 4 số cuối PAN.",
    "payment_description_payment_instrument_id" to "Mã định danh công cụ thanh toán được mã hóa.",
    "payment_request_payment_sca_all" to "SCA thanh toán (tất cả các yếu tố dữ liệu)",
    "payment_request_payment_sca_minimal" to "SCA thanh toán (tối thiểu)",
    "payment_request_payment_sca_transaction" to "SCA với giao dịch thanh toán"
)
